const languageCodes = {
    EN: 'EN',
    CS: 'CS',
    SYSTEM: 'SYSTEM',
};

export default languageCodes;
